import React, { useEffect, useState } from 'react';
import { Button, Form, FormControl, Modal } from 'react-bootstrap';
import Avatar from '../../components/Avatar';
import { Link } from 'react-router-dom';
import { USER_PROFILE } from '../../constants/routes';
import Loader from '../../components/Loader';
import API from '../../API';

const UserInfoModal = ({ user, handleClose }) => {
  const [bankAccounts, setBankAccounts] = useState([]);
  const [isLoading, setIsLoading] = useState(null);
  const [isVerifying, setIsVerifying] = useState(false);
  useEffect(() => {
    if (user) {
      setIsLoading(true);
      API.get(`bank-accounts/${user.id}`)
        .then(resp => {
          setBankAccounts(resp);
          setIsLoading(false);
          return resp;
        })
        .catch(err => {
          setIsLoading(false);
          console.log(err);
        });
    } else {
      setBankAccounts([]);
    }
  }, [user]);
  const verifyUser = () => {
    setIsVerifying(true);
    API.post(`user/${user.id}/verify`)
      .then(resp => {
        handleClose(resp);
      })
      .finally(() => {
        setIsVerifying(false);
      });
  };
  return (
    <Modal show={!!user} onHide={handleClose} centered size="lg">
      {!!user && (
        <>
          <Modal.Header closeButton>
            <Modal.Title className="d-flex align-items-center">
              <Avatar size={50} image={user.avatar} className="mr-2" /> {user.name}{' '}
              <span className="text-gray">{user.nickname ? '@' + user.nickname : ''}</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {user.verified !== 1 && (
              <Loader isLoadin={isVerifying} height={72} size={50}>
                <Button className="btn btn-success mb-2" onClick={verifyUser}>
                  Verify
                </Button>
              </Loader>
            )}
            <div className="row">
              <div className="col-md-6">
                <h4>Profile Info</h4>
                <div className="row row-cols-2">
                  <div className="col">Name</div>
                  <div className="col">{user.name}</div>

                  <div className="col">Nickname</div>
                  <div className="col">{user.nickname}</div>
                  <div className="col">Verified Status</div>
                  <div className="col">
                    {user.verified === 0 ? (
                      <span className="text-warning">Pending</span>
                    ) : user.verified === 1 ? (
                      <span className="text-success">Verified</span>
                    ) : (
                      'none'
                    )}
                  </div>
                  <div className="col">Subscription Price</div>
                  <div className="col">{user.subscription_price}</div>

                  <div className="col">Email</div>
                  <div className="col">{user.email}</div>

                  <div className="col">Email Notifications</div>
                  <div className="col">{user.email_notifications ? 'On' : 'Off'}</div>

                  <div className="col">Location</div>
                  <div className="col">{user.location}</div>

                  <div className="col">Website</div>
                  <div className="col">{user.website}</div>

                  <div className="col">About</div>
                  <div className="col text-break">{user.about}</div>
                </div>
              </div>
              <div className="col-md-6">
                <h4>Bank Account Info</h4>
                <div className="row row-cols-2">
                  <Loader isLoadin={isLoading} height={80} size={60}>
                    {!!bankAccounts.length &&
                      bankAccounts.map(acc => (
                        <>
                          <div className="col">Name</div>
                          <div className="col">{acc.name_on_account}</div>
                          <div className="col">Routing Number</div>
                          <div className="col">{acc.routing_number}</div>
                          <div className="col">Checking Number</div>
                          <div className="col">{acc.account_number}</div>
                          <div className="col">
                            <img
                              src={acc.front_id}
                              style={{ maxHeight: 200 }}
                              className="img-fluid"
                              alt="Responsive image"
                            />
                          </div>
                          <div className="col">
                            <img
                              src={acc.back_id}
                              style={{ maxHeight: 200 }}
                              className="img-fluid"
                              alt="Responsive image"
                            />
                          </div>
                          <hr />
                          <hr />
                        </>
                      ))}
                  </Loader>
                </div>
              </div>
            </div>
          </Modal.Body>
        </>
      )}
    </Modal>
  );
};

export default UserInfoModal;
